import {azureConnection} from "@/services/forms/app/recovery/connection/azure";
import {awsConnection} from "@/services/forms/app/recovery/connection/aws";
import {awsS3Compatible} from "@/services/forms/app/recovery/connection/awsS3Compatible";
import {googleCloudPlatform} from "@/services/forms/app/recovery/connection/googleCloudPlatform";

const setupConnection = (storageDestinationType, regionOption, regionPlaceholder) => (
  storageDestinationType === '1' ? awsConnection(regionOption, regionPlaceholder)
    : storageDestinationType === '2' ? azureConnection
      : storageDestinationType === '7' ? awsS3Compatible(regionOption, regionPlaceholder)
        : storageDestinationType === '8' ? googleCloudPlatform(regionOption, regionPlaceholder)
          : {}
)

const getSetupConnectionConfig = (storageDestinationType) => {
  const type = String(storageDestinationType);

  const oauthMap = {
    '3': 'connectGoogle',
    '4': 'connectMicrosoft',
    '5': 'connectDropbox',
    '6': 'connectBox'
  };

  const oauthAction = oauthMap[type];

  if (oauthAction) {
    return {
      isOauth: true,
      actionName: `salesforce/recovery/salesforce/${oauthAction}`
    };
  }

  const regionAction = type === '8' ? 'listRegionGCP' : 'listRegion';

  return {
    isOauth: false,
    actionName: `salesforce/recovery/salesforce/${regionAction}`
  };
};

export {
  setupConnection,
  getSetupConnectionConfig
}
